import {IComponentOptions, IOnDestroy} from "angular";
import template from "../temp-and-delayed-price-message/TempAndDelayedPriceMessagePromptComponent.html";
import "./TempAndDelayedPriceMessagePromptComponent.scss";
import {ReplaySubject} from "rxjs";

export const TempAndDelayedPricePrompt = "tfTempAndDelayedPricePrompt";

export function tempAndDelayedPricePrompt(): IComponentOptions {
    return {
        template,
        controller: TempAndDelayedPriceSystemPromptComponentController
    };
}

export class TempAndDelayedPriceSystemPromptComponentController implements IOnDestroy {
    private readonly destroy$ = new ReplaySubject<boolean>(1);

    /** @ngInject */
    public constructor() {

    }

    public $onDestroy() {
        this.destroy$.next(true);
        this.destroy$.complete();
    }
}
